import { Component, OnInit } from '@angular/core';
import { SessionData } from 'src/app/shared/localstorage/sessionData';
import { Router } from '@angular/router';


@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goBack(): void {
    window.history.back();
  }

  goToHome() {
    if (SessionData.getCurrentUser().admin) {
      this.router.navigateByUrl('/admin');
    }
    else {
      this.router.navigateByUrl('/home');
    }
  }
}
